import { ChangeEvent, useEffect, useState } from 'react';
import {
  Typography,
  Container,
  Grid,
  styled,
  Paper,
  useTheme,
  useMediaQuery,
  Box,
  Button,
  FormControlLabel,
  Checkbox,
  TextField,
} from '@mui/material';
import Page from '../components/Page';
import { useNavigate } from 'react-router-dom';

import visaDebito from '../assets/payments/logo-visa-debito.png';
import mercadopago from '../assets/payments/logo-mercadopago.png';
import interbanking from '../assets/payments/logo-interbanking.png';
import epagos_credito_debito from '../assets/payments/epagos-credito-debito.png';
import epagos_billetera from '../assets/payments/epagos-billetera.png';
import epagos_homebanking from '../assets/payments/epagos-homebanking.png';
import epagos_transferencia from '../assets/payments/epagos-transferencia.png';
import epagos_img from '../assets/payments/logo-epagos.png';

import PaymentModal from '../components/PaymentModal';
import {
  //decidirPayments, 
  //getDecidirPayments, 
  epagosPayments,
  getEpagosPayments
} from '../features/payments/paymentsSlice';
import { useSelector } from 'react-redux';
import { store } from '../store';
import { currentComprobante } from '../features/comprobantes/comprobantesSlice';
import {
  esComprobanteNotif,
  getIdentificadorImponible,
  getLabelClaveComprobante,
  getTipoComprobante
} from '../utils';
import moment from 'moment';
import CheckboxIcon from '../assets/icons/checkbox-icon';
import UncheckedIcon from '../assets/icons/uncheckbox-icon';
import * as yup from 'yup';
import { getUser } from '../features/login/loginSlice';
import PaymentSlider from '../components/PaymentSlider';

const MainWrapper = styled(Paper)(({ theme }) => ({
  border: '1px solid',
  borderColor: theme.palette.grey[300],
  display: 'flex',
  flexDirection: 'column',
  padding: '2rem',
  [theme.breakpoints.down('md')]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
}));

const CustomButton = styled(Button)(() => ({
  color: 'white',
  padding: '.4rem 2rem',
  fontSize: '.75rem',
  fontWeight: '700',
}));

const PaymentButton = styled(Paper)(() => ({
  border: '1.5px solid',
  width: '100%',
  color: 'white',
  padding: '1rem 1.5rem',
  fontSize: '.75rem',
  fontWeight: '700',
  marginBottom: '1rem',
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

const CuotaWrapper = styled(Paper)(() => ({
  padding: '.5rem',
  border: '1.5px solid',
  borderColor: '#E4E6EF',
  margin: '0 .5rem .5rem 0',
}));

const MainGrid = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    justifyContent: 'center',
  },
}));

const FirstGrid = styled(Grid)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
}));

const TextingGrid = styled(Grid)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  [theme.breakpoints.down('md')]: {
    marginTop: '2rem',
    width: '90%',
    paddingLeft: 0,
  },
}));

const CuotasWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  [theme.breakpoints.down('md')]: {
    justifyContent: 'center',
  },
}));

const CustomTextReminder = styled(Typography)(() => ({
  backgroundColor: '#36b7e8',
  color: '#ffffff',
  padding: 10,
  borderRadius: 5,
  fontWeight: 600,
}));


const getPaymentMethodImage = (method: string) => {
  /*
  switch (method) {
    case 'AMEX': return amExpress;
    case 'VISA': return visa;
    case 'DINERS': return diners;
    case 'MASTERCARD': return mastercard;
    case 'PAGOMISCUENTAS': return pagoMisCuentas;
    case 'PAGO_ONLINE': return epagos_img;
    default: return visaDebito;
  }*/
  switch (method) {
    case 'TARJETAS_DE_CREDITO': return epagos_credito_debito;
    case 'TARJETAS_DE_DEBITO': return epagos_credito_debito;
    case 'HOMBANKING': return epagos_homebanking;
    case 'BILLETERA': return epagos_billetera;
    case 'DEBIN_DEBITO_DIRECTO': return epagos_transferencia;
    case 'BILLETERA_T3.0': return epagos_billetera;
    case 'DEBITO_DIRECTO_CBU': return epagos_transferencia;
    case 'PAGO_ONLINE': return epagos_img;
    default: return visaDebito;
  }
};

const getPaymentMethodTxt = (method: string) => {
  switch (method) {
    case 'TARJETAS_DE_CREDITO': return "TARJETAS DE CREDITO";
    case 'TARJETAS_DE_DEBITO': return "TARJETAS DE DEBITO";
    case 'HOMBANKING': return "HOMBANKING";
    case 'BILLETERA': return "BILLETERA";
    case 'DEBIN_DEBITO_DIRECTO': return "DEBIN DEBITO DIRECTO";
    case 'BILLETERA_T3.0': return "BILLETERA T3";
    case 'DEBITO_DIRECTO_CBU': return "DEBITO DIRECTO CBU";
    default: return "Pago online";
  }
};

export default function Payment() {
  const theme = useTheme();
  const navigate = useNavigate();
  const desktop = useMediaQuery(theme.breakpoints.up('md'));

  const user = useSelector(getUser);
  if (!user) {
    return null;
  }

  const comprobante = useSelector(currentComprobante);

  ///E-pagos///
  const epagosMethods = useSelector(epagosPayments);

  const [payMethod, setPayMethod] = useState('');
  const [total, setTotal] = useState<string>();
  const [openModal, setOpenModal] = useState(false);
  const [periodos, setPeriodos] = useState<string[]>();

  const [detailLabel, setDetailLabel] = useState('');

  const [enviarEmail, setEnviarMail] = useState(false);
  const [email, setEmail] = useState(user.email);
  const [emailErrors, setEmailErrors] = useState('');

  const emailSchema = yup.object().shape({
    email: yup
      .string()
      .email('Ingrese un email válido')
      .required('El campo email es obligatorio'),
  });

  const handleEmailChange = async (event: ChangeEvent<HTMLInputElement>) => {
    setEmailErrors('');

    const newEmail = event.target.value;

    setEmail(newEmail);

    try {
      await emailSchema.validate({ email: newEmail });
    } catch (err) {
      if (err instanceof yup.ValidationError && err.errors.length > 0) {
        setEmailErrors(err.errors.join('. '));
      }
    }
  };

  useEffect(() => {
    if (!comprobante) {
      navigate('/');
      return;
    }

    //store.dispatch(getDecidirPayments());

    store.dispatch(getEpagosPayments());

    const newPeriodos = comprobante.cuotas
      .filter((cuota, idx) => {
        return comprobante.cuotas.findIndex(c => c.cuota == cuota.cuota && c.anio == cuota.anio) === idx;
      })
      .sort((a, b) => {
        return parseInt(a.anio) * 100 + parseInt(a.cuota) - parseInt(b.anio) * 100 + parseInt(b.cuota);
      })
      .map(c => {
        if (comprobante.tipo_comprob == '18') {
          return `ANUAL ${c.anio}`;
        }

        return `${c.cuota}${c.anio != '0' ? '/' + c.anio : ''}`;
      });

    setPeriodos(newPeriodos);

    let newLabel = 'Estas pagando ';
    if (esComprobanteNotif(comprobante)) {
      const tipoComprobante = getTipoComprobante(comprobante);
      newLabel += `la notificación n° ${comprobante.id_in} correspondiente al `;
      newLabel += `${getLabelClaveComprobante(tipoComprobante)} ${getIdentificadorImponible(comprobante)} `;
      newLabel += 'que incluye ';

      const fechaVto = moment(comprobante.fecha_vto, 'DD/MM/YYYY').endOf('day');
      const vencido = fechaVto.isSameOrBefore();

      if (vencido) {
        setTotal(comprobante.monto_total);
      } else {
        setTotal(comprobante.monto_dto);
      }
    } else {
      setTotal(comprobante.monto);
    }

    if (comprobante.cuotas.length > 1) {
      newLabel += 'todas las cuotas entre ';
      newLabel += newPeriodos[0];
      newLabel += ' y la cuota ';
      newLabel += newPeriodos.slice(-1);
    } else if (comprobante.tipo_comprob == '18') {
      newLabel += `la cuota ANUAL ${+ comprobante.cuotas[0].anio}`;
    } else {
      newLabel += `la cuota ${comprobante.cuotas[0].cuota}/${+ comprobante.cuotas[0].anio}`;
    }

    setDetailLabel(newLabel);
  }, [comprobante]);

  const [cardContent, setCardContent] = useState(false);
  const showCardContent = () => {
    setCardContent(!cardContent);
  }

  return (
    <Page>
      <Container>
        <Grid
          container
          padding={'1.875rem'}
          justifyContent="center"
          direction={desktop ? 'row' : 'column'}
        >
          <Grid item sm={10} sx={{ alignSelf: 'center' }}>
            <Box mb={3}>
              <MainWrapper>
                <MainGrid container direction="row">
                  <FirstGrid item md={7}>
                    <Box>
                      <Typography variant="subtitle1" mb="1rem">
                        ¿Cómo querés pagar?
                      </Typography>
                      <Typography variant="body1" mb="1rem">{detailLabel}</Typography>
                      <CuotasWrapper>
                        {
                          periodos?.map((periodo, idx) => (
                            <CuotaWrapper key={idx}>
                              <Typography>
                                Cuota {periodo}
                              </Typography>
                            </CuotaWrapper>
                          ))
                        }
                      </CuotasWrapper>
                      <Box sx={{ marginTop: '2rem' }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={enviarEmail}
                              onClick={() => setEnviarMail(!enviarEmail)}
                              icon={<UncheckedIcon />}
                              checkedIcon={<CheckboxIcon />}
                            />
                          }
                          label="Enviar comprobante por email"
                        /><br />
                        {
                          enviarEmail
                            ? <TextField
                              variant="outlined"
                              id="email"
                              label={'Email'}
                              value={email}
                              onChange={handleEmailChange}
                              sx={{
                                minWidth: {
                                  xs: '20rem',
                                  sm: '25rem',
                                  md: '19rem',
                                  lg: '30rem',
                                }
                              }
                              }
                              error={!!emailErrors}
                              helperText={emailErrors}
                            />
                            : null
                        }
                      </Box>
                    </Box>

                    <Typography variant="subtitle2" mt="1rem" sx={{ fontWeight: '600' }}>
                      Total a pagar: $ {total}
                    </Typography>
                  </FirstGrid>
                  <TextingGrid item md={5} pl={5}>
                    {
                      comprobante && !esComprobanteNotif(comprobante)
                        ? <CustomTextReminder mb="1rem">
                          IMPORTANTE: En caso de cancelación total de contado se aplicará un descuento del 25% sobre
                          los intereses generados.
                        </CustomTextReminder>
                        : null
                    }
                    <Box>
                      <Typography
                        variant="subtitle2"
                        mb="1rem"
                        sx={{ textAlign: 'center' }}
                      >
                        Elegí tu método de pago
                      </Typography>

                      {/* E-pagos */}
                      {
                        epagosMethods.map((method, i) => (
                          <>
                            <PaymentButton
                              key={i}
                              onClick={() => { setPayMethod(`epagos-${method}`); setOpenModal(!openModal) }}
                              sx={{
                                boxShadow: 1,
                                borderColor: `epagos-${method}` === payMethod
                                  ? '#36B7E8'
                                  : '#E4E6EF',
                                backgroundColor: `epagos-${method}` === payMethod
                                  ? 'rgba(54, 183, 232, 0.1)'
                                  : 'transparent',
                              }}
                            >
                              <Typography sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                                {getPaymentMethodTxt(method)}
                              </Typography>

                            </PaymentButton>
                            <PaymentSlider />
                          </>
                        ))
                      }

                      <PaymentButton
                        onClick={() => { setPayMethod('mercadopago'); setOpenModal(!openModal) }}
                        sx={{
                          display: import.meta.env.VITE_EPAGOS === 'true' ? 'none' : 'flex',
                          boxShadow: 1,
                          borderColor: 'interbanking' === payMethod ? '#36B7E8' : '#E4E6EF',
                          backgroundColor: 'interbanking' === payMethod ? 'rgba(54, 183, 232, 0.1)' : 'transparent',
                        }}
                      >
                        <img
                          src={mercadopago}
                          style={{ maxWidth: '100%', height: '1.3rem' }}
                        />
                      </PaymentButton>

                      <PaymentButton
                        onClick={() => { setPayMethod('interbanking'); setOpenModal(!openModal) }}
                        sx={{
                          display: import.meta.env.VITE_EPAGOS === 'true' ? 'none' : 'flex',
                          boxShadow: 1,
                          borderColor: 'interbanking' === payMethod ? '#36B7E8' : '#E4E6EF',
                          backgroundColor: 'interbanking' === payMethod ? 'rgba(54, 183, 232, 0.1)' : 'transparent',
                        }}
                      >
                        <img
                          src={interbanking}
                          style={{ maxWidth: '100%', height: '1.3rem', margin: '0rem 1rem' }}
                        />
                      </PaymentButton>



                    </Box>
                  </TextingGrid>
                </MainGrid>

                <Box mt={2} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <CustomButton
                    onClick={() => navigate(-1)}
                    variant="contained"
                  >
                    Volver
                  </CustomButton>

                </Box>
              </MainWrapper>
            </Box>
          </Grid>
        </Grid>
      </Container>
      {
        comprobante && periodos
          ? <PaymentModal
            openModal={openModal}
            setOpenModal={setOpenModal}
            metodo={payMethod}
            periodos={periodos}
            tipoComprobante={comprobante.tipo_comprob}
            nroComprobante={comprobante.nro_comprob}
            total={total ?? '0.00'}
            sendMail={enviarEmail ? email : undefined}
          />
          : null
      }
    </Page>
  );
}
